

















































import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';

@Component({
  components: {EditDialog, SelectDialogField},
})
export default class PModuleHeaterMonitorTreeEditDialog extends Mixins(EditDialogMixin) {
  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  get unstatusItems() {
    return [
      {
        name: 'Выключено',
        value: 0,
      },
      {
        name: 'Холостой режим',
        value: 1,
      },
      {
        name: 'Рабочий режим',
        value: 2,
      },
      {
        name: 'Ошибка',
        value: 3,
      },
    ];
  }
}
